// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Admin Dashboard (presentation view) ─── */

.admin-dashboard {
  animation: dashboardFadeIn 0.5s ease-out;
}

@keyframes dashboardFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hero — фон как у admin-navigation */
.dashboard-hero {
  position: relative;
  border-radius: 14px;
  padding: 1.5rem 1.5rem 1.25rem;
  margin-bottom: 2.5rem;
  overflow: hidden;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #1e293b;
  box-shadow: none;
}

.dashboard-hero-content {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 1.25rem;
}

.dashboard-hero-badge {
  display: inline-block;
  padding: 0.35rem 0.85rem;
  border-radius: 10px;
  background: white;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-bottom: 0.75rem;
  border: 1px solid #e2e8f0;
  color: #1e3a8a;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.dashboard-hero-title {
  margin: 0 0 0.5rem;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #1e293b;
}

.dashboard-hero-subtitle {
  margin: 0;
  font-size: 0.95rem;
  color: #64748b;
  max-width: 520px;
  line-height: 1.5;
}

.dashboard-refresh-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.15rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: white;
  color: #475569;
  font-weight: 600;
  font-size: 0.88rem;
  cursor: pointer;
  transition: all 0.25s ease;
}

.dashboard-refresh-btn:hover:not(:disabled) {
  background: white;
  border-color: #3bbddb;
  color: #1e3a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(59, 189, 219, 0.15);
}

.dashboard-refresh-btn:disabled {
  opacity: 0.7;
  cursor: wait;
}

.dashboard-refresh-icon {
  display: inline-block;
  font-size: 1.1rem;
  line-height: 1;
}

.dashboard-refresh-icon.spinning {
  animation: spin 0.8s linear infinite;
}

/* KPI row */
.dashboard-kpi-row {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.85rem;
}

.dashboard-kpi {
  padding: 1rem 1.1rem;
  border-radius: 10px;
  background: white;
  border: 1px solid #e2e8f0;
  animation: kpiSlideUp 0.6s ease-out both;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  min-width: 0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.dashboard-kpi--metric {
  min-height: 96px;
}

.dashboard-kpi-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0.4rem;
  line-height: 1.35;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.dashboard-kpi-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.1;
  color: #1e3a8a;
}

.dashboard-kpi-value--accent {
  text-shadow: none;
}

.dashboard-kpi:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
}

@keyframes kpiSlideUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dashboard-kpi--primary {
  background: white;
}

.dashboard-kpi--highlight {
  grid-column: span 1;
  background: white;
}

.dashboard-kpi-bar {
  margin-top: 0.5rem;
  height: 4px;
  border-radius: 2px;
  background: #e2e8f0;
  overflow: hidden;
}

.dashboard-kpi-bar-fill {
  height: 100%;
  border-radius: 2px;
  background: #2563eb;
  transition: width 1.2s cubic-bezier(0.22, 1, 0.36, 1);
  animation: barGrow 1.2s ease-out both;
}

@keyframes barGrow {
  from { transform: scaleX(0); transform-origin: left; }
  to { transform: scaleX(1); }
}

/* Teams section */
.dashboard-teams-section {
  margin-bottom: 2.5rem;
}

.dashboard-section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.dashboard-section-header h3 {
  margin: 0 0 0.25rem;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.02em;
}

.dashboard-section-header p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}

.dashboard-section-count {
  flex-shrink: 0;
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(59, 189, 219, 0.12), rgba(37, 99, 235, 0.1));
  color: #2563eb;
  font-size: 0.82rem;
  font-weight: 600;
  border: 1px solid rgba(59, 189, 219, 0.25);
}

.dashboard-teams-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.25rem;
}

/* Team cards */
.dashboard-team-card {
  --team-accent: #3bbddb;
  position: relative;
  background: white;
  border-radius: 18px;
  padding: 1.35rem 1.35rem 1.1rem;
  border: 1px solid #e8eef4;
  box-shadow:
    0 4px 24px rgba(15, 23, 42, 0.06),
    0 0 0 1px rgba(255, 255, 255, 0.8) inset;
  overflow: hidden;
  animation: cardReveal 0.55s ease-out both;
  transition:
    transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.35s ease;
}

@keyframes cardReveal {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.dashboard-team-card:hover {
  transform: translateY(-6px);
  box-shadow:
    0 20px 40px rgba(30, 58, 138, 0.12),
    0 0 0 1px rgba(59, 189, 219, 0.15);
}

.dashboard-team-card-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--team-accent), color-mix(in srgb, var(--team-accent) 60%, #667eea));
}

.dashboard-team-card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.dashboard-team-score-ring {
  position: relative;
  width: 64px;
  height: 64px;
  flex-shrink: 0;
}

.dashboard-team-score-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.dashboard-team-score-bg {
  fill: none;
  stroke: #eef2f7;
  stroke-width: 3;
}

.dashboard-team-score-fill {
  fill: none;
  stroke: var(--team-accent);
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dasharray 1.1s cubic-bezier(0.22, 1, 0.36, 1);
  filter: drop-shadow(0 0 4px color-mix(in srgb, var(--team-accent) 50%, transparent));
}

.dashboard-team-score-value {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
}

.dashboard-team-card-title h4 {
  margin: 0 0 0.2rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}

.dashboard-team-rank {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--team-accent);
  background: color-mix(in srgb, var(--team-accent) 12%, white);
  padding: 0.15rem 0.45rem;
  border-radius: 6px;
  margin-bottom: 0.35rem;
}

.dashboard-team-meta {
  margin: 0;
  font-size: 0.82rem;
  color: #94a3b8;
}

.dashboard-team-metrics {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-bottom: 1rem;
}

.dashboard-metric-row-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.3rem;
}

.dashboard-metric-label {
  font-size: 0.72rem;
  color: #64748b;
  line-height: 1.35;
  flex: 1 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.dashboard-metric-percent {
  font-size: 0.78rem;
  font-weight: 700;
  flex-shrink: 0;
}

.dashboard-metric-track {
  height: 6px;
  border-radius: 3px;
  background: #f1f5f9;
  overflow: hidden;
}

.dashboard-metric-fill {
  height: 100%;
  border-radius: 3px;
  transform-origin: left;
  animation: metricFillGrow 1s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes metricFillGrow {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

.dashboard-team-card-footer {
  padding-top: 0.75rem;
  border-top: 1px solid #f1f5f9;
}

.dashboard-detail-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.65rem 1rem;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  color: #334155;
  font-weight: 600;
  font-size: 0.88rem;
  cursor: pointer;
  transition: all 0.25s ease;
}

.dashboard-detail-btn:hover {
  background: linear-gradient(135deg, var(--team-accent), color-mix(in srgb, var(--team-accent) 70%, #2563eb));
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px color-mix(in srgb, var(--team-accent) 35%, transparent);
}

.dashboard-detail-arrow {
  transition: transform 0.25s ease;
}

.dashboard-detail-btn:hover .dashboard-detail-arrow {
  transform: translateX(4px);
}

/* Empty state */
.dashboard-empty-state {
  text-align: center;
  padding: 3.5rem 2rem;
  border-radius: 18px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px dashed #cbd5e1;
  animation: dashboardFadeIn 0.5s ease;
}

.dashboard-empty-icon {
  font-size: 2.5rem;
  display: block;
  margin-bottom: 0.75rem;
  animation: emptyBounce 2s ease-in-out infinite;
}

@keyframes emptyBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

.dashboard-empty-state h4 {
  margin: 0 0 0.5rem;
  color: #334155;
  font-size: 1.1rem;
}

.dashboard-empty-state p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}

/* Charts section (dashboard variant) */
.dashboard-charts-section {
  margin-top: 0.5rem;
}

.dashboard-charts-section .charts-section-header {
  text-align: center;
  margin-bottom: 1.75rem;
}

.dashboard-charts-section .charts-section-header h3 {
  margin: 0 0 0.35rem;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.02em;
}

.dashboard-charts-section .charts-section-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.88rem;
}

.dashboard-charts-section .charts-grid {
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 480px), 1fr));
  gap: 1.5rem;
}

.dashboard-charts-section .chart-container {
  position: relative;
  border-radius: 18px;
  padding: 1.25rem;
  background: white;
  border: 1px solid #e8eef4;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
  animation: chartReveal 0.6s ease-out both;
  transition:
    transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.35s ease;
  overflow: hidden;
}

@keyframes chartReveal {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.dashboard-charts-section .chart-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 40px rgba(30, 58, 138, 0.12);
}

.dashboard-charts-section .chart-container-glow {
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at 50% 0%, rgba(59, 189, 219, 0.08), transparent 60%);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

.dashboard-charts-section .chart-container:hover .chart-container-glow {
  opacity: 1;
}

.dashboard-charts-section .chart-container::after {
  content: 'Увеличить';
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 0.3rem 0.65rem;
  border-radius: 8px;
  background: rgba(30, 58, 138, 0.85);
  color: white;
  font-size: 0.72rem;
  font-weight: 600;
  opacity: 0;
  transform: translateY(-4px);
  transition: all 0.25s ease;
  z-index: 5;
}

.dashboard-charts-section .chart-container:hover::after {
  opacity: 1;
  transform: translateY(0);
}

/* Dark theme */
.admin-dashboard.dark-theme .dashboard-section-header h3,
.admin-dashboard.dark-theme .dashboard-charts-section .charts-section-header h3 {
  color: #f1f5f9;
}

.admin-dashboard.dark-theme .dashboard-section-header p,
.admin-dashboard.dark-theme .dashboard-charts-section .charts-section-subtitle {
  color: #94a3b8;
}

.admin-dashboard.dark-theme .dashboard-section-count {
  background: rgba(59, 189, 219, 0.15);
  color: #7dd3fc;
  border-color: rgba(59, 189, 219, 0.3);
}

.admin-dashboard.dark-theme .dashboard-team-card {
  background: #1e293b;
  border-color: #334155;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
}

.admin-dashboard.dark-theme .dashboard-team-score-bg {
  stroke: #334155;
}

.admin-dashboard.dark-theme .dashboard-team-score-value,
.admin-dashboard.dark-theme .dashboard-team-card-title h4 {
  color: #f1f5f9;
}

.admin-dashboard.dark-theme .dashboard-metric-track {
  background: #334155;
}

.admin-dashboard.dark-theme .dashboard-team-card-footer {
  border-top-color: #334155;
}

.admin-dashboard.dark-theme .dashboard-detail-btn {
  background: #334155;
  color: #e2e8f0;
}

.admin-dashboard.dark-theme .dashboard-empty-state {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-color: #475569;
}

.admin-dashboard.dark-theme .dashboard-empty-state h4 {
  color: #e2e8f0;
}

.admin-dashboard.dark-theme .dashboard-empty-state p {
  color: #94a3b8;
}

.admin-dashboard.dark-theme .dashboard-charts-section .chart-container {
  background: #1e293b;
  border-color: #334155;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
}

.admin-dashboard.dark-theme .dashboard-hero {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
  box-shadow: none;
}

.admin-dashboard.dark-theme .dashboard-hero-badge {
  background: #334155;
  border-color: #475569;
  color: #7dd3fc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.admin-dashboard.dark-theme .dashboard-hero-title {
  color: #f1f5f9;
}

.admin-dashboard.dark-theme .dashboard-hero-subtitle {
  color: #94a3b8;
}

.admin-dashboard.dark-theme .dashboard-refresh-btn {
  background: #334155;
  border-color: #475569;
  color: #cbd5e0;
}

.admin-dashboard.dark-theme .dashboard-refresh-btn:hover:not(:disabled) {
  background: #475569;
  border-color: #3bbddb;
  color: #7dd3fc;
}

.admin-dashboard.dark-theme .dashboard-kpi {
  background: #334155;
  border-color: #475569;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.admin-dashboard.dark-theme .dashboard-kpi-label {
  color: #94a3b8;
}

.admin-dashboard.dark-theme .dashboard-kpi-value {
  color: #7dd3fc;
}

.admin-dashboard.dark-theme .dashboard-kpi-bar {
  background: #475569;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-hero {
    padding: 1.5rem 1.25rem 1.25rem;
    border-radius: 16px;
  }

  .dashboard-hero-content {
    flex-direction: column;
    align-items: stretch;
  }

  .dashboard-refresh-btn {
    align-self: flex-start;
  }

  .dashboard-kpi-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .dashboard-kpi--highlight {
    grid-column: span 2;
  }

  .dashboard-teams-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-section-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .dashboard-kpi-row {
    grid-template-columns: 1fr;
  }

  .dashboard-kpi--highlight {
    grid-column: span 1;
  }

  .dashboard-kpi-label {
    font-size: 0.68rem;
  }

  .dashboard-kpi-value {
    font-size: 1.25rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .admin-dashboard,
  .dashboard-kpi,
  .dashboard-team-card,
  .dashboard-charts-section .chart-container,
  .dashboard-empty-icon {
    animation: none !important;
  }

  .dashboard-metric-fill,
  .dashboard-kpi-bar-fill,
  .dashboard-team-score-fill {
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminDashboard.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;EACxC,uDAAuD;EACvD,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,OAAO,oBAAoB,EAAE,sBAAsB,EAAE;EACrD,KAAK,oBAAoB,EAAE;AAC7B;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,qFAAqF;EACrF,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB;;4CAE0C;EAC1C,gBAAgB;EAChB,yCAAyC;EACzC;;yBAEuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2GAA2G;AAC7G;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,gEAAgE;EAChE,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,6DAA6D;EAC7D,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,SAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4GAA4G;EAC5G,YAAY;EACZ,2BAA2B;EAC3B,8EAA8E;AAChF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,6DAA6D;EAC7D,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;EAC7C,yCAAyC;EACzC;;yBAEuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wFAAwF;EACxF,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,eAAe;AACf;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;;EAEA;;;IAGE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ─── Admin Dashboard (presentation view) ─── */\r\n\r\n.admin-dashboard {\r\n  animation: dashboardFadeIn 0.5s ease-out;\r\n}\r\n\r\n@keyframes dashboardFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(12px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Hero — фон как у admin-navigation */\r\n.dashboard-hero {\r\n  position: relative;\r\n  border-radius: 14px;\r\n  padding: 1.5rem 1.5rem 1.25rem;\r\n  margin-bottom: 2.5rem;\r\n  overflow: hidden;\r\n  background: #f1f5f9;\r\n  border: 1px solid #e2e8f0;\r\n  color: #1e293b;\r\n  box-shadow: none;\r\n}\r\n\r\n.dashboard-hero-content {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 1.5rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.dashboard-hero-badge {\r\n  display: inline-block;\r\n  padding: 0.35rem 0.85rem;\r\n  border-radius: 10px;\r\n  background: white;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  margin-bottom: 0.75rem;\r\n  border: 1px solid #e2e8f0;\r\n  color: #1e3a8a;\r\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\r\n}\r\n\r\n.dashboard-hero-title {\r\n  margin: 0 0 0.5rem;\r\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\r\n  font-weight: 700;\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.2;\r\n  color: #1e293b;\r\n}\r\n\r\n.dashboard-hero-subtitle {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n  color: #64748b;\r\n  max-width: 520px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.dashboard-refresh-btn {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.65rem 1.15rem;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  background: white;\r\n  color: #475569;\r\n  font-weight: 600;\r\n  font-size: 0.88rem;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.dashboard-refresh-btn:hover:not(:disabled) {\r\n  background: white;\r\n  border-color: #3bbddb;\r\n  color: #1e3a8a;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 16px rgba(59, 189, 219, 0.15);\r\n}\r\n\r\n.dashboard-refresh-btn:disabled {\r\n  opacity: 0.7;\r\n  cursor: wait;\r\n}\r\n\r\n.dashboard-refresh-icon {\r\n  display: inline-block;\r\n  font-size: 1.1rem;\r\n  line-height: 1;\r\n}\r\n\r\n.dashboard-refresh-icon.spinning {\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n/* KPI row */\r\n.dashboard-kpi-row {\r\n  position: relative;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 0.85rem;\r\n}\r\n\r\n.dashboard-kpi {\r\n  padding: 1rem 1.1rem;\r\n  border-radius: 10px;\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  animation: kpiSlideUp 0.6s ease-out both;\r\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\r\n}\r\n\r\n.dashboard-kpi--metric {\r\n  min-height: 96px;\r\n}\r\n\r\n.dashboard-kpi-label {\r\n  display: block;\r\n  font-size: 0.68rem;\r\n  font-weight: 500;\r\n  color: #64748b;\r\n  margin-bottom: 0.4rem;\r\n  line-height: 1.35;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  hyphens: auto;\r\n}\r\n\r\n.dashboard-kpi-value {\r\n  display: block;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.1;\r\n  color: #1e3a8a;\r\n}\r\n\r\n.dashboard-kpi-value--accent {\r\n  text-shadow: none;\r\n}\r\n\r\n.dashboard-kpi:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);\r\n}\r\n\r\n@keyframes kpiSlideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(16px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.dashboard-kpi--primary {\r\n  background: white;\r\n}\r\n\r\n.dashboard-kpi--highlight {\r\n  grid-column: span 1;\r\n  background: white;\r\n}\r\n\r\n.dashboard-kpi-bar {\r\n  margin-top: 0.5rem;\r\n  height: 4px;\r\n  border-radius: 2px;\r\n  background: #e2e8f0;\r\n  overflow: hidden;\r\n}\r\n\r\n.dashboard-kpi-bar-fill {\r\n  height: 100%;\r\n  border-radius: 2px;\r\n  background: #2563eb;\r\n  transition: width 1.2s cubic-bezier(0.22, 1, 0.36, 1);\r\n  animation: barGrow 1.2s ease-out both;\r\n}\r\n\r\n@keyframes barGrow {\r\n  from { transform: scaleX(0); transform-origin: left; }\r\n  to { transform: scaleX(1); }\r\n}\r\n\r\n/* Teams section */\r\n.dashboard-teams-section {\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.dashboard-section-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  gap: 1rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.dashboard-section-header h3 {\r\n  margin: 0 0 0.25rem;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n  color: #1e293b;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.dashboard-section-header p {\r\n  margin: 0;\r\n  color: #64748b;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.dashboard-section-count {\r\n  flex-shrink: 0;\r\n  padding: 0.4rem 0.9rem;\r\n  border-radius: 999px;\r\n  background: linear-gradient(135deg, rgba(59, 189, 219, 0.12), rgba(37, 99, 235, 0.1));\r\n  color: #2563eb;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  border: 1px solid rgba(59, 189, 219, 0.25);\r\n}\r\n\r\n.dashboard-teams-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n  gap: 1.25rem;\r\n}\r\n\r\n/* Team cards */\r\n.dashboard-team-card {\r\n  --team-accent: #3bbddb;\r\n  position: relative;\r\n  background: white;\r\n  border-radius: 18px;\r\n  padding: 1.35rem 1.35rem 1.1rem;\r\n  border: 1px solid #e8eef4;\r\n  box-shadow:\r\n    0 4px 24px rgba(15, 23, 42, 0.06),\r\n    0 0 0 1px rgba(255, 255, 255, 0.8) inset;\r\n  overflow: hidden;\r\n  animation: cardReveal 0.55s ease-out both;\r\n  transition:\r\n    transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),\r\n    box-shadow 0.35s ease;\r\n}\r\n\r\n@keyframes cardReveal {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px) scale(0.97);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.dashboard-team-card:hover {\r\n  transform: translateY(-6px);\r\n  box-shadow:\r\n    0 20px 40px rgba(30, 58, 138, 0.12),\r\n    0 0 0 1px rgba(59, 189, 219, 0.15);\r\n}\r\n\r\n.dashboard-team-card-accent {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: linear-gradient(90deg, var(--team-accent), color-mix(in srgb, var(--team-accent) 60%, #667eea));\r\n}\r\n\r\n.dashboard-team-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.dashboard-team-score-ring {\r\n  position: relative;\r\n  width: 64px;\r\n  height: 64px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dashboard-team-score-svg {\r\n  width: 100%;\r\n  height: 100%;\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n.dashboard-team-score-bg {\r\n  fill: none;\r\n  stroke: #eef2f7;\r\n  stroke-width: 3;\r\n}\r\n\r\n.dashboard-team-score-fill {\r\n  fill: none;\r\n  stroke: var(--team-accent);\r\n  stroke-width: 3;\r\n  stroke-linecap: round;\r\n  transition: stroke-dasharray 1.1s cubic-bezier(0.22, 1, 0.36, 1);\r\n  filter: drop-shadow(0 0 4px color-mix(in srgb, var(--team-accent) 50%, transparent));\r\n}\r\n\r\n.dashboard-team-score-value {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n  color: #1e293b;\r\n}\r\n\r\n.dashboard-team-card-title h4 {\r\n  margin: 0 0 0.2rem;\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: #1e293b;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.dashboard-team-rank {\r\n  display: inline-block;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  color: var(--team-accent);\r\n  background: color-mix(in srgb, var(--team-accent) 12%, white);\r\n  padding: 0.15rem 0.45rem;\r\n  border-radius: 6px;\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.dashboard-team-meta {\r\n  margin: 0;\r\n  font-size: 0.82rem;\r\n  color: #94a3b8;\r\n}\r\n\r\n.dashboard-team-metrics {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.65rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.dashboard-metric-row-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n  margin-bottom: 0.3rem;\r\n}\r\n\r\n.dashboard-metric-label {\r\n  font-size: 0.72rem;\r\n  color: #64748b;\r\n  line-height: 1.35;\r\n  flex: 1;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  hyphens: auto;\r\n}\r\n\r\n.dashboard-metric-percent {\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dashboard-metric-track {\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  background: #f1f5f9;\r\n  overflow: hidden;\r\n}\r\n\r\n.dashboard-metric-fill {\r\n  height: 100%;\r\n  border-radius: 3px;\r\n  transform-origin: left;\r\n  animation: metricFillGrow 1s cubic-bezier(0.22, 1, 0.36, 1) both;\r\n}\r\n\r\n@keyframes metricFillGrow {\r\n  from { transform: scaleX(0); }\r\n  to { transform: scaleX(1); }\r\n}\r\n\r\n.dashboard-team-card-footer {\r\n  padding-top: 0.75rem;\r\n  border-top: 1px solid #f1f5f9;\r\n}\r\n\r\n.dashboard-detail-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  width: 100%;\r\n  padding: 0.65rem 1rem;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\r\n  color: #334155;\r\n  font-weight: 600;\r\n  font-size: 0.88rem;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.dashboard-detail-btn:hover {\r\n  background: linear-gradient(135deg, var(--team-accent), color-mix(in srgb, var(--team-accent) 70%, #2563eb));\r\n  color: white;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 16px color-mix(in srgb, var(--team-accent) 35%, transparent);\r\n}\r\n\r\n.dashboard-detail-arrow {\r\n  transition: transform 0.25s ease;\r\n}\r\n\r\n.dashboard-detail-btn:hover .dashboard-detail-arrow {\r\n  transform: translateX(4px);\r\n}\r\n\r\n/* Empty state */\r\n.dashboard-empty-state {\r\n  text-align: center;\r\n  padding: 3.5rem 2rem;\r\n  border-radius: 18px;\r\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\r\n  border: 2px dashed #cbd5e1;\r\n  animation: dashboardFadeIn 0.5s ease;\r\n}\r\n\r\n.dashboard-empty-icon {\r\n  font-size: 2.5rem;\r\n  display: block;\r\n  margin-bottom: 0.75rem;\r\n  animation: emptyBounce 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes emptyBounce {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-8px); }\r\n}\r\n\r\n.dashboard-empty-state h4 {\r\n  margin: 0 0 0.5rem;\r\n  color: #334155;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.dashboard-empty-state p {\r\n  margin: 0;\r\n  color: #64748b;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Charts section (dashboard variant) */\r\n.dashboard-charts-section {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.dashboard-charts-section .charts-section-header {\r\n  text-align: center;\r\n  margin-bottom: 1.75rem;\r\n}\r\n\r\n.dashboard-charts-section .charts-section-header h3 {\r\n  margin: 0 0 0.35rem;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n  color: #1e293b;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.dashboard-charts-section .charts-section-subtitle {\r\n  margin: 0;\r\n  color: #64748b;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.dashboard-charts-section .charts-grid {\r\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 480px), 1fr));\r\n  gap: 1.5rem;\r\n}\r\n\r\n.dashboard-charts-section .chart-container {\r\n  position: relative;\r\n  border-radius: 18px;\r\n  padding: 1.25rem;\r\n  background: white;\r\n  border: 1px solid #e8eef4;\r\n  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);\r\n  animation: chartReveal 0.6s ease-out both;\r\n  transition:\r\n    transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),\r\n    box-shadow 0.35s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes chartReveal {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px) scale(0.98);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.dashboard-charts-section .chart-container:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 16px 40px rgba(30, 58, 138, 0.12);\r\n}\r\n\r\n.dashboard-charts-section .chart-container-glow {\r\n  position: absolute;\r\n  inset: -50%;\r\n  background: radial-gradient(circle at 50% 0%, rgba(59, 189, 219, 0.08), transparent 60%);\r\n  opacity: 0;\r\n  transition: opacity 0.4s ease;\r\n  pointer-events: none;\r\n}\r\n\r\n.dashboard-charts-section .chart-container:hover .chart-container-glow {\r\n  opacity: 1;\r\n}\r\n\r\n.dashboard-charts-section .chart-container::after {\r\n  content: 'Увеличить';\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  padding: 0.3rem 0.65rem;\r\n  border-radius: 8px;\r\n  background: rgba(30, 58, 138, 0.85);\r\n  color: white;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  opacity: 0;\r\n  transform: translateY(-4px);\r\n  transition: all 0.25s ease;\r\n  z-index: 5;\r\n}\r\n\r\n.dashboard-charts-section .chart-container:hover::after {\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n}\r\n\r\n/* Dark theme */\r\n.admin-dashboard.dark-theme .dashboard-section-header h3,\r\n.admin-dashboard.dark-theme .dashboard-charts-section .charts-section-header h3 {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-section-header p,\r\n.admin-dashboard.dark-theme .dashboard-charts-section .charts-section-subtitle {\r\n  color: #94a3b8;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-section-count {\r\n  background: rgba(59, 189, 219, 0.15);\r\n  color: #7dd3fc;\r\n  border-color: rgba(59, 189, 219, 0.3);\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-team-card {\r\n  background: #1e293b;\r\n  border-color: #334155;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-team-score-bg {\r\n  stroke: #334155;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-team-score-value,\r\n.admin-dashboard.dark-theme .dashboard-team-card-title h4 {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-metric-track {\r\n  background: #334155;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-team-card-footer {\r\n  border-top-color: #334155;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-detail-btn {\r\n  background: #334155;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-empty-state {\r\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\r\n  border-color: #475569;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-empty-state h4 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-empty-state p {\r\n  color: #94a3b8;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-charts-section .chart-container {\r\n  background: #1e293b;\r\n  border-color: #334155;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-hero {\r\n  background: #1e293b;\r\n  border-color: #334155;\r\n  color: #e2e8f0;\r\n  box-shadow: none;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-hero-badge {\r\n  background: #334155;\r\n  border-color: #475569;\r\n  color: #7dd3fc;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-hero-title {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-hero-subtitle {\r\n  color: #94a3b8;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-refresh-btn {\r\n  background: #334155;\r\n  border-color: #475569;\r\n  color: #cbd5e0;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-refresh-btn:hover:not(:disabled) {\r\n  background: #475569;\r\n  border-color: #3bbddb;\r\n  color: #7dd3fc;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-kpi {\r\n  background: #334155;\r\n  border-color: #475569;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-kpi-label {\r\n  color: #94a3b8;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-kpi-value {\r\n  color: #7dd3fc;\r\n}\r\n\r\n.admin-dashboard.dark-theme .dashboard-kpi-bar {\r\n  background: #475569;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .dashboard-hero {\r\n    padding: 1.5rem 1.25rem 1.25rem;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .dashboard-hero-content {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .dashboard-refresh-btn {\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .dashboard-kpi-row {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .dashboard-kpi--highlight {\r\n    grid-column: span 2;\r\n  }\r\n\r\n  .dashboard-teams-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .dashboard-section-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .dashboard-kpi-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .dashboard-kpi--highlight {\r\n    grid-column: span 1;\r\n  }\r\n\r\n  .dashboard-kpi-label {\r\n    font-size: 0.68rem;\r\n  }\r\n\r\n  .dashboard-kpi-value {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .admin-dashboard,\r\n  .dashboard-kpi,\r\n  .dashboard-team-card,\r\n  .dashboard-charts-section .chart-container,\r\n  .dashboard-empty-icon {\r\n    animation: none !important;\r\n  }\r\n\r\n  .dashboard-metric-fill,\r\n  .dashboard-kpi-bar-fill,\r\n  .dashboard-team-score-fill {\r\n    transition: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
